export default __webpack_public_path__ + "static/media/search-notification-light.f5bcd4f4.svg";